<div class="flex justify-between items-center mb-4">
  <h2 class="text-2xl font-semibold">Profesiones</h2>
  <button
    (click)="openModal('add')"
    class="bg-primary text-white px-4 py-2 rounded transform transition-transform duration-200 cursor-pointer hover:scale-105"
    [disabled]="loadingProfessions"
  >
    Crear nueva profesión
  </button>
</div>
<app-loading
  *ngIf="loadingProfessions"
  text="Cargando profesiones"
></app-loading>
<div
  class="bg-white rounded border border-gray-200"
  *ngIf="!loadingProfessions"
>
  <app-table-generic
    [columns]="columns"
    [data]="professions"
    [actions]="actions"
    [showPagination]="false"
    (edit)="openModal('edit', $event)"
  >
  </app-table-generic>
</div>
<app-modal-form
  *ngIf="mostrarModalAgregar"
  [title]="'Crear profesión'"
  [form]="formAgregar"
  [fields]="fieldsAgregar"
  [loading]="loadingAgregar"
  (formSubmit)="crearProfession()"
  (cancel)="mostrarModalAgregar = false"
  submitText="Crear"
>
</app-modal-form>
<app-modal-form
  *ngIf="mostrarModalEditar"
  [title]="'Editar profesión'"
  [form]="formEditar"
  [fields]="fieldsEditar"
  [loading]="loadingEditar"
  submitText="Actualizar"
  (formSubmit)="actualizarProfession()"
  (cancel)="mostrarModalEditar = false"
>
</app-modal-form>
